import {
    ADD_COMMENT,
    BLOGS_POST_FORM_ONE_OF_COMMENT_PHOTO_OR_STICKER_IS_REQUIRED,
    SEND_COMMENT,
} from 'mk/autogenerated/translations/MessageForm.db04312817f112d69d04b8d96948e121'
import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import AvatarImg from 'mk2/components/AvatarImg';
import { BtnType } from 'mk2/components/Btn';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import TextareaField from 'mk2/components/forms/TextareaField';
import { ComposeToolbar } from 'mk2/containers/Toolbar/Toolbar';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { UserEntity } from 'mk2/schemas';
import * as React from 'react';
import { FormErrors } from 'redux-form';
import styles from './MessageForm.mscss';

interface OwnProps {
    postKey: string;
    requestUser: UserEntity;
    initialValues: CommentFormData;
    textareaRef?: (r: HTMLTextAreaElement) => void;

    onSend(commentFd: CommentFormData);
}

type Props = OwnProps;

const validate = (values: CommentFormData): FormErrors<CommentFormData> => {
    const errors: FormErrors<CommentFormData> = {};

    if (!values.text && (!values.photos || !values.photos.length) && !values.sticker) {
        errors.text = BLOGS_POST_FORM_ONE_OF_COMMENT_PHOTO_OR_STICKER_IS_REQUIRED;
    }

    return errors;
};

class MessageFormComponent extends React.Component<Props & MKReduxFormInjectedProps> {

    private emojisConfig = {
        fields: ['text'],
        defaultField: 'text',
    };

    private photosConfig = {
        photoType: 'comment',
        multiple: false,
        showPhotoCode: false,
    };

    public render() {
        const { requestUser, handleSubmit, form } = this.props;

        return (
            <div className={styles.MessageForm}>
                <span className={styles.MessageForm__avatar}>
                    <AvatarImg user={requestUser} size={32}/>
                </span>

                <span className={styles.MessageForm__form}>
                    <form onSubmit={handleSubmit}>
                        <div className={styles.MessageForm__form__comment}>
                            <TextareaField
                                name="text"
                                placeholder={ADD_COMMENT}
                                rows={3}
                                textareaRef={this.props.textareaRef}
                                bottomBorder={false}
                                isCompact
                            />
                        </div>
                    </form>
                    <ComposeToolbar
                        formName={form}

                        emojis={this.emojisConfig}
                        photos={this.photosConfig}

                        rightAction={
                            <SubmitButton
                                btnType={BtnType.BzGreen}
                                className={styles.MessageForm__button}
                                label={SEND_COMMENT}
                                formName={form}
                            />
                        }
                        isInBlogs
                    />
                </span>
            </div>
        );
    }
}

export const MessageFormFactory = (formName: string) => mkReduxFormNew<CommentFormData, Props>({
    formName,
    onValidate: validate,
    onSave: (values, props) => props.onSend(values),
})(MessageFormComponent);
